import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import _ from 'lodash';

import { setEmbedParams } from 'client/actions';
import {
	EMBED_SCRIPT_MESSAGE_SENDER_ID,
	STORY_MESSAGE_SENDER_ID,
	embedingEvent,
	CARD_ROOT_ID,
} from 'client/constants/common';
import { ClientReducerState } from 'src/routes/client/reducers';
import { EmbedScriptMessage, StoryMessage } from 'src/sdk';

const postMessage = (data: StoryMessage['data']) => {
	console.info('EmbedingConnect.postMessage', data);
	window.parent.postMessage({ ...data, sender: STORY_MESSAGE_SENDER_ID }, '*');
};

const mapState = (state: ClientReducerState) => ({
	cardId: _.get(state, 'card._id', ''),
});

const mapDispatch = {
	setEmbedParams,
};

const connector = connect(mapState, mapDispatch);

type Props = ConnectedProps<typeof connector>;

class EmbedingConnect extends React.PureComponent<Props> {
	isRafActive: boolean = false;

	viewportSize: { w?: number; h: number } = {
		w: 0,
		h: 0,
	};

	componentDidMount() {
		this.addResizeListener();
		window.addEventListener('message', this.onWindowMessage);

		postMessage({ type: embedingEvent.STORY_IS_READY, payload: undefined });
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.cardId !== prevProps.cardId) {
			const cardContainer = document.getElementById(CARD_ROOT_ID) as HTMLDivElement;

			postMessage({
				type: embedingEvent.CARD_CHANGED,
				payload: { cardHeight: cardContainer.offsetHeight },
			});
		}
	}

	componentWillUnmount() {
		this.removeResizeListener();
		window.removeEventListener('message', this.onWindowMessage);
	}

	addResizeListener = () => {
		this.isRafActive = true;
		this.onRAF();
	};

	removeResizeListener = () => {
		this.isRafActive = false;
	};

	onRAF = () => {
		const cardContainer = document.getElementById(CARD_ROOT_ID) as HTMLDivElement;

		const viewportSize = {
			w: cardContainer ? cardContainer.offsetWidth : 0,
			h: cardContainer ? cardContainer.offsetHeight : 0,
		};

		if (!_.isEqual(viewportSize, this.viewportSize)) {
			postMessage({ type: embedingEvent.STORY_RESIZE, payload: viewportSize });
			this.viewportSize = viewportSize;
		}

		if (this.isRafActive) {
			window.requestAnimationFrame(this.onRAF);
		}
	};

	onWindowMessage = (event: { data: EmbedScriptMessage }) => {
		if (event.data.sender !== EMBED_SCRIPT_MESSAGE_SENDER_ID) {
			return;
		}

		// console.info('EmbedingConnect.onWindowMessage', type, payload);

		switch (event.data.type) {
			case embedingEvent.PAGE_IS_READY: {
				if (event.data.payload.autoHeight) {
					const html = document.querySelector('html');

					if (html) html.style.overflow = 'hidden';
				}
				this.props.setEmbedParams(event.data.payload);
				break;
			}

			case embedingEvent.PAGE_SCROLL:
				window.dispatchEvent(
					new CustomEvent('pageScroll', {
						detail: {
							pageYOffset: event.data.payload.pageYOffset,
							viewport: event.data.payload.viewport,
							containerPosTop: event.data.payload.containerPosTop,
						},
					})
				);
				break;

			case embedingEvent.STORY_IN_VIEWPORT:
				break;

			default:
				break;
		}
	};

	render() {
		return null;
	}
}

export default connector(EmbedingConnect);
